import { getTableIntentLink } from "@components/drillDown/DrillDown.utils";
import {
    FilterBarGroup,
    getDefaultFilterGroupDef,
    IFilterGroupDef
} from "@components/smart/smartFilterBar/SmartFilterBar.types";
import { IReportHierarchy } from "@components/smart/smartTable";
import { IFormatOptions } from "@odata/OData.utils";
import { CommonReportProps } from "@pages/reports/CommonDefs";
import {
    composedDateRangeOnBeforeLoadCallback,
    getComposedDateRangeFieldsDefs
} from "@pages/reports/customFilterComponents/ComposedDateRange";
import {
    getEmployeeNumberOursCommonDef,
    getPayslipCommonDef,
    payslipInitialSortBy
} from "@pages/reports/payrollOverview/PayrollOverview.utils";
import { setReportDef } from "@pages/reports/Report.test.utils";
import { ReportStorage } from "@pages/reports/ReportStorage";
import { isDefined } from "@utils/general";
import i18next from "i18next";

import { TValue } from "../../../global.types";
import { ROUTE_DEDUCTIONS } from "../../../routes";
import { IReportTableDefinition, TReportColumnOverrides } from "../Report.utils";
import { ReportId } from "../ReportIds";

export const getDefinition = (): IReportTableDefinition => {
    const tableId = ReportId.DeductionOverview;
    const title = i18next.t("Reporting:DeductionOverview.Title");
    const path = "DeductionsOverview";

    const filterBarDef: IFilterGroupDef[] = [{
        ...getDefaultFilterGroupDef(FilterBarGroup.Parameters),
        defaultFilters: [
            CommonReportProps.dateRange,
            CommonReportProps.dateRangeCustomValue,
        ],
        filterDefinition: {
            ...getComposedDateRangeFieldsDefs(tableId, true),
        },
    }, {
        ...getDefaultFilterGroupDef(FilterBarGroup.Filters),
        allowCustomFilters: false,
        defaultFilters: [],
        filterDefinition: {}
    }];

    const onBeforeLoad = async (storage: ReportStorage) => {
        await composedDateRangeOnBeforeLoadCallback(storage, false, true, true);
    };

    const parameters: string[] = [CommonReportProps.dateRange, CommonReportProps.dateRangeCustomValue];
    const defaultReportHierarchy: IReportHierarchy = {
        "Aggregate": false,
        "Groups": [],
        "Columns": [
            {
                "ColumnAlias": "YearMonth",
            },
            {
                "ColumnAlias": "PrEmployee_NumberOurs"
            },
            {
                "ColumnAlias": "Name"
            },
            {
                "ColumnAlias": "PrPayslipItem_TypeName"
            },
            {
                "ColumnAlias": "PrPayslipItem_DeductionType"
            },
            {
                "ColumnAlias": "PrPayslipItem_Value"
            }
        ],
        "Aggregations": []
    };

    const columnOverrides: TReportColumnOverrides = {
        YearMonth: getPayslipCommonDef(),
        PrEmployee_NumberOurs: getEmployeeNumberOursCommonDef(),
        PrPayslipItem_TypeName: {
            formatter: (val: TValue, args: IFormatOptions) => {
                const deductionId = args.entity["PrPayslipItem_DeductionId"];
                if (!isDefined(deductionId)) {
                    return val?.toString();
                }
                return getTableIntentLink(val?.toString(), {
                    route: `${ROUTE_DEDUCTIONS}/${deductionId}`,
                    context: args.context
                });
            }
        }
    };

    const initialSortBy = payslipInitialSortBy;

    return {
        title,
        path,
        id: tableId,
        initialSortBy,
        columnOverrides,
        filterBarDef,
        onBeforeLoad,
        parameters,
        defaultReportHierarchy
    };
};

setReportDef(ReportId.DeductionOverview, getDefinition);